import React, { createContext, useContext, useState } from "react";

interface LessonsNavDrawerContextValue {
  isNavDrawerOpen: boolean;
  openNavDrawer: () => void;
  closeNavDrawer: () => void;
}

const LessonsNavDrawerContext =
  createContext<LessonsNavDrawerContextValue | null>(null);

export function LessonsNavDrawerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isNavDrawerOpen, setIsNavDrawerOpen] = useState(false);

  const value: LessonsNavDrawerContextValue = React.useMemo(
    () => ({
      isNavDrawerOpen,
      openNavDrawer: () => setIsNavDrawerOpen(true),
      closeNavDrawer: () => setIsNavDrawerOpen(false),
    }),
    [isNavDrawerOpen],
  );

  return (
    <LessonsNavDrawerContext.Provider value={value}>
      {children}
    </LessonsNavDrawerContext.Provider>
  );
}

export function useLessonsNavDrawer(): LessonsNavDrawerContextValue {
  const context = useContext(LessonsNavDrawerContext);
  if (!context) {
    throw new Error(
      "useLessonsNavDrawer must be used within a LessonsNavDrawerProvider",
    );
  }
  return context;
}
